import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { IError } from "itsf-ui-common";
import { useElavonPaymentIframe } from "@common/PaymentIframe/elavon/useElavonPaymentIframe";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { Error } from "@common/HandleErrorAndLoading/Error";

interface IParams {
    validatePaymentApiRoute: string;
    iframePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const ElavonPaymentIframe = (props: IParams) => {
    const { validatePaymentApiRoute, iframePaymentApiRoute, successCallback, errorCallback } = props;
    const { t } = useTranslation(["payment", "common"]);
    const { classes } = useStyle();

    const {
        iframeKey,
        getIFrame,
        iframeFetchState: { isLoading, error },
    } = useElavonPaymentIframe({
        validatePaymentApiRoute,
        iframePaymentApiRoute,
        successCallback,
        errorCallback,
    });

    return (
        <div className={classes.container}>
            {isLoading && <AbsoluteLoader />}
            {!error && (
                <iframe
                    className={classes.iframe}
                    data-testid="card-iframe"
                    id="target-iframe"
                    key={iframeKey}
                    title={t("payment:paymentIframe")}
                />
            )}
            {error && <Error error={error} retryFetch={getIFrame} />}
        </div>
    );
};
